import React from "react";

const BADGE_STYLES = {
    approved: "bg-[#d4f0e4] text-[#186b48]",
    pending: "bg-[#fff6d3] text-[#997e16]",
    "no-show": "bg-[#f3e3e0] text-[#9a5b4d]",
    "not-checked-in": "bg-[#e6e7e9] text-[#5e5e5e]",
    rejected: "bg-[#fdd8d8] text-[#c52e2e]",
};

const BADGE_LABELS = {
    approved: "Approved",
    pending: "Pending",
    "no-show": "No show",
    "not-checked-in": "Not checked in",
    rejected: "Rejected",
};

export default function StatusBadge({ status }) {
    return (
        <span
            className={`inline-block px-[14px] py-[3px] rounded-full text-[14px] tracking-[0.8px] uppercase whitespace-nowrap ${
                BADGE_STYLES[status] || BADGE_STYLES.pending
            }`}
        >
            {BADGE_LABELS[status] || status}
        </span>
    );
}
